const NAVBAR_HEIGHT = 80;

export function scrollToAnchor(anchor) {
  if (!anchor) return;
  const el = document.getElementById(anchor);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT - 12;
  window.scrollTo({ top, behavior: 'smooth' });

  el.classList.add('search-highlight');
  const removeHighlight = () => {
    el.classList.remove('search-highlight');
    document.removeEventListener('click', removeHighlight, true);
    document.removeEventListener('keydown', removeHighlight, true);
    document.removeEventListener('scroll', removeHighlight, { once: true, passive: true });
  };
  setTimeout(() => {
    document.addEventListener('click', removeHighlight, true);
    document.addEventListener('keydown', removeHighlight, true);
    document.addEventListener('scroll', removeHighlight, { once: true, passive: true });
  }, 800);
}

// Polls until the element exists (handles async page mounts) then scrolls.
export function scrollToAnchorWithRetry(anchor, intervalMs = 150, maxAttempts = 12) {
  if (!anchor) return;
  let attempts = 0;
  const try_ = () => {
    const el = document.getElementById(anchor);
    if (el) {
      scrollToAnchor(anchor);
    } else if (++attempts < maxAttempts) {
      setTimeout(try_, intervalMs);
    }
  };
  setTimeout(try_, 100);
}
